<nav class="navbar navbar-expand-lg navbar-light  site-navbar" style="z-index: 1000;">
  <a class="navbar-brand" routerLink="/"><img class="custom-lg-logo" src="assets/img/logo.svg" alt=""></a>
  <a class="navbar-brand " routerLink="/"><img class="custom-logo" src="assets/img/vpostcode-small-logo.svg" alt=""></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="" (click)="toggleNav()"
    aria-controls="navbarSupportedContent"  aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse navbar-custom" id="navbarSupportedContent" #navheader>
    <ul class="navbar-nav mr-auto ml-xl-5">
      <li class="nav-item active">
        <a class="nav-link nav_item" routerLink="/" routerLinkActive="nav-hightlight"
          [routerLinkActiveOptions]="{exact:true}">Trang chủ </a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle nav_item" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Giới thiệu
        </a>
        <ul class="dropdown-menu dropdown-menu-center " aria-labelledby="navbarDropdown">

          <li>
            <a class="dropdown-item item-dropdown_custom" routerLink="/about">
              <h6 style="font-weight: bolder;">Vpostcode là gì ?</h6>
              <pre style="font-family: sans-serif;"> Giới thiệu về Vpostcode </pre>
            </a>
          </li>
          <li>
            <a class="dropdown-item item-dropdown_custom" routerLink="/about">
              <h6 style="font-weight: bolder;">Nguyên tắc gán mã</h6>
              <pre style="font-family: sans-serif;">Giới thiệu về cách thức
hoạt động của Vpostcode</pre>
            </a>
          </li>
          <li>
            <a class="dropdown-item item-dropdown_custom" routerLink="/about">
              <h6 style="font-weight: bolder;">Tầm nhìn</h6>
              <pre style="font-family: sans-serif;">Định hướng tương lai
phát triển của Vpostcode</pre>
            </a>
          </li>
          <li>
            <a class="dropdown-item item-dropdown_custom">
              <h6 style="font-weight: bolder;">Đơn vị chủ quan</h6>
            </a>
          </li>
        </ul>
      </li>
      <li class="nav-item">
        <a class="nav-link nav_item" routerLink="/benefit" routerLinkActive="nav-hightlight"
          [routerLinkActiveOptions]="{exact:true}">Lợi ích </a>
      </li>

      <li class="nav-item">
        <a class="nav-link nav_item  " routerLink="/question" routerLinkActive="nav-hightlight"
          [routerLinkActiveOptions]="{exact:true}">Hỏi đáp</a>
      </li>
      <li class="nav-item ">
        <a class="nav-link nav_item " routerLink="/contact" routerLinkActive="nav-hightlight"
          [routerLinkActiveOptions]="{exact:true}">Liên hệ</a>
      </li>
    </ul>
    <ul class="navbar-nav mr-auto flex-row">

      <li class="nav-item ">
        <form class="form-inline my-2 my-lg-0 right-nav" *ngIf="url != 'map'">

          <p-autoComplete name="autocomplete" [suggestions]="dataSearch" (completeMethod)="onChangeSearch($event)"
            field="name" [dropdown]="false">
            <ng-template let-country pTemplate="item">
              <div class="country-item" (click)="selectEvent(country)">
                <div>{{country.name}}</div>
              </div>
            </ng-template>
          </p-autoComplete>
          <button pButton type="button" class="p-button-info-custom " (click)="getDefaultLocation()"><i
              class="search-icon"></i></button>
        </form>
      </li>
      <li class="nav-item" *ngIf="isLoginStatus==false">
        <a class="nav-link nav_item" style="color: #004686;" (click)="logIn()">Đăng nhập </a>
      </li>
      <li class="nav-item" *ngIf="isLoginStatus==true">
        <a class="nav-link nav_item" style="color: #004686;" (click)="logOut()">Đăng xuất </a>
      </li>

    </ul>

  </div>



</nav>
